export default __webpack_public_path__ + "assets/hotelrichland.f562d274.jpg";